interface SelectAllBannerProps {
  pageCount: number;
  totalCount: number;
  selectAllFilteredMode: boolean;
  onSelectAll: () => void;
  onClear: () => void;
}

export function SelectAllBanner({
  pageCount,
  totalCount,
  selectAllFilteredMode,
  onSelectAll,
  onClear,
}: SelectAllBannerProps) {
  if (totalCount <= pageCount) return null;

  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-rounded-md tw-border tw-border-blue-200 tw-bg-blue-50 tw-px-4 tw-py-2 tw-text-sm tw-text-blue-900">
      {selectAllFilteredMode ? (
        <>
          <span>
            All {totalCount.toLocaleString()} influencers matching current
            filters are selected.
          </span>
          <button
            onClick={onClear}
            className="tw-font-medium tw-text-blue-700 tw-underline hover:tw-text-blue-900"
          >
            Clear selection
          </button>
        </>
      ) : (
        <>
          <span>All {pageCount} influencers on this page are selected.</span>
          <button
            onClick={onSelectAll}
            className="tw-font-medium tw-text-blue-700 tw-underline hover:tw-text-blue-900"
          >
            Select all {totalCount.toLocaleString()} influencers matching
            current filters
          </button>
        </>
      )}
    </div>
  );
}
